<widget id="funds-vcc-widget" title="VCC Bank Accounts" [subTitle]="'Distribution VCCs funding.'+ (dateFilterText | async)">
  <div id="funds-vcc-chart-wrap" class="widget-chart-wrap" widgetContent>
    <div *ngIf="isLoading && !loadingState$" id="funds-vcc-loading" class="loading-container">
      <mat-spinner diameter="30"></mat-spinner>
      <span>Loading chart data...</span>
    </div>

    <div *ngIf="isError && !isLoading" id="funds-vcc-error" class="error-container">
      <mat-icon>info</mat-icon>
      <span>No data for the chosen parameters.</span>
    </div>

    <chart *ngIf="!isLoading && !isError && dataChart" id="funds-vcc-chart"
      [dataSet]="dataChart"
      [chartType]="'doughnut'"
      (chartClick)="FundsVccClickHandler($event)"
      [options]="fundsVccChartOptions">
    </chart>

    <div *ngIf="!isLoading && !isError && (!dataChart || (dataChart.labels && dataChart.labels.length === 0))" id="funds-vcc-empty" class="empty-container">
      <mat-icon>info</mat-icon>
      <span>No data for the chosen parameters.</span>
    </div>
  </div>
</widget>
